import { primaryColor } from './colors';

export const typography =  {
    fontFamily: 'Urbanist, Arial, sans-serif',
    h1: {
      fontWeight: 700,
      color: primaryColor
    },
    h2: {
      fontWeight: 700,
      color: primaryColor
    },
    h3: {
      fontWeight: 700,
      color: primaryColor
    },
    h4: {
      fontWeight: 700,
      color: primaryColor
    },
    h6: {
      fontWeight: 500,
      color: primaryColor
    },
  }